<div class="container">
    <div class="d-flex flex-column flex-md-row align-items-center gap-2 my-2">
        <div class="col-8 col-md-4 col-xl-2 mr-4 my-2">
            <app-search-box 
                (search)="onSearch($event)"
            ></app-search-box>
        </div>
    </div>
    <table *ngIf="showTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover" style="width:100%"></table>
    
    <ng-template #actionsRef let-data="adtData" let-emitter="captureEvents">
        <app-edit [data]="data" (emitter)="emitter($event)"></app-edit>
    </ng-template>
</div>
